<template>
  <div class="not-found-container">
    <div class="not-found-content">
      <h1 class="not-found-title">404</h1>
      <p class="not-found-text">抱歉，您访问的页面不存在</p>
      <p class="not-found-subtext">可能是页面已被删除或链接有误</p>
      <router-link to="/" class="back-home-btn">
        返回首页
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  metaInfo: {
    title: '页面未找到 - 禾苗（武汉）信息技术有限公司'
  }
}
</script>

<style scoped>
.not-found-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 70vh;
  background-color: #f8f9fa;
  padding: 2rem 0;
}

.not-found-content {
  text-align: center;
  background: #fff;
  padding: 4rem 2rem;
  border-radius: 10px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  width: 90%;
  animation: fadeIn 0.8s ease-out;
}

.not-found-title {
  font-size: 6rem;
  font-weight: 700;
  color: #007bff;
  margin-bottom: 1rem;
  line-height: 1;
}

.not-found-text {
  font-size: 1.5rem;
  color: #343a40;
  margin-bottom: 0.5rem;
  font-weight: 500;
}

.not-found-subtext {
  font-size: 1rem;
  color: #6c757d;
  margin-bottom: 2rem;
}

.back-home-btn {
  display: inline-block;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  font-weight: 500;
  color: #fff;
  background-color: #007bff;
  border: none;
  border-radius: 4px;
  text-decoration: none;
  transition: all 0.3s ease;
  cursor: pointer;
}

.back-home-btn:hover {
  background-color: #0056b3;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
  color: #fff;
  text-decoration: none;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .not-found-container {
    min-height: 60vh;
  }
  
  .not-found-content {
    padding: 3rem 1.5rem;
  }
  
  .not-found-title {
    font-size: 4rem;
  }
  
  .not-found-text {
    font-size: 1.25rem;
  }
}

@media (max-width: 480px) {
  .not-found-content {
    padding: 2rem 1rem;
  }
  
  .not-found-title {
    font-size: 3rem;
  }
  
  .not-found-text {
    font-size: 1.1rem;
  }
  
  .back-home-btn {
    padding: 0.6rem 1.5rem;
    font-size: 0.9rem;
  }
}
</style>